import { MERCHANT_OPERATIONS } from "@price-rescue/api-contracts";
import type {
  ProductBulkMonitoringInput,
  ProductBulkMonitoringPreview,
  ProductBulkMonitoringResult,
} from "@price-rescue/api-contracts";
import type { MerchantApiClient } from "../../types.js";
import { freezeProductBulkSelection } from "./product-bulk-selection.js";

export interface ProductBulkMonitoringService {
  preview(input: ProductBulkMonitoringInput): Promise<ProductBulkMonitoringPreview>;
  execute(
    input: ProductBulkMonitoringInput,
    idempotencyKey: string,
  ): Promise<ProductBulkMonitoringResult>;
}

export function createProductBulkMonitoringService(
  client: Pick<MerchantApiClient, "operation">,
): ProductBulkMonitoringService {
  return {
    async preview(input) {
      const response = await client.operation<{ data: ProductBulkMonitoringPreview }>(
        MERCHANT_OPERATIONS.previewProductBulkMonitoring,
        { body: freezeInput(input) },
      );
      return response.data;
    },
    async execute(input, idempotencyKey) {
      const response = await client.operation<{ data: ProductBulkMonitoringResult }>(
        MERCHANT_OPERATIONS.updateProductBulkMonitoring,
        { body: freezeInput(input), request: { idempotencyKey } },
      );
      return response.data;
    },
  };
}

function freezeInput(input: ProductBulkMonitoringInput): ProductBulkMonitoringInput {
  return { ...input, productIds: freezeProductBulkSelection([...input.productIds]) };
}
